import { render, staticRenderFns } from "./downloadApp.vue?vue&type=template&id=0553be00&scoped=true&"
import script from "./downloadApp.vue?vue&type=script&lang=js&"
export * from "./downloadApp.vue?vue&type=script&lang=js&"
import style0 from "./downloadApp.vue?vue&type=style&index=0&id=0553be00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553be00",
  null
  
)

export default component.exports